<i [ngClass]="icon" aria-hidden="true"></i>
